export default {
    index: "Dashboard",
    users: "Nutzer",
    organisations: "Organisationen",
    "settings-loginProviders": "Login Methoden"
}
